quoteModule.controller('quoteCustomerInfoController',
['$scope','$rootScope', 'quoteCreationEvents','rateQuoteCoordService','rateQuoteRetrievalCoordService',
    'quoteInitializationService','contractCreationService','quoteIntegrationConstants','erateSessionVarsService', 'locationService', 'growl',
function ($scope, $rootScope, quoteCreationEvents, rateQuoteCoordService,rateQuoteRetrievalCoordService,
          quoteInitializationService,contractCreationService, quoteIntegrationConstants,erateSessionVarsService, locationService, growl) {
    var self = this;
    /*
    This controller reacts to the customer information directive. We cast events as customer information is changed,
    and if the customer information meets minimum requirements to save a quote, it attempts to save a quote. Please
    note, unless a product rate is chosen, we don't really save just when customer info changes.

    When we first come in to this controller, we first see if our customer information is being sent in via integration
    data.
    */
    //customer information data model - utilizes the service's .CustomerData object
    $scope.customerDefinition;// = rateQuoteCoordService.CustomerData;

    $scope.contractsProcessing = contractCreationService.contractsProcessing;
    $scope.quoteMode = null;
    $scope.menuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
    $scope.menuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;

    //initialize the directive with the controller
    this.init = function(element){
        self.$element = element;
        rateQuoteCoordService.clearCustomer();
        $scope.customerDefinition = rateQuoteCoordService.CustomerData;
        $scope.quoteMode = erateSessionVarsService.getQuotingMode();
        quoteInitializationService.signalChildReady('customerReady');
    }
    //the customer data changed
    $scope.customerChanged = function(){
        //making sure the data changed is copying back to shared service
        //rateQuoteCoordService.CustomerData = $scope.customerDefinition;
        //anytime something changes, we "end" quote retrieval so that we can save
        rateQuoteRetrievalCoordService.endQuoteRetrieval();
        //broadcasting the change to the customer-card-controller
        $rootScope.$broadcast(quoteCreationEvents.customerDataChange, $scope.customerDefinition);
        //need to add validation of some sort before "capturing"
        if (rateQuoteCoordService.CustomerData.dataReadyToSaveQuote()) {
            $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
        }
    }



    $scope.clearNames = function() {
        $scope.customerDefinition.BuyerInfo.firstName = '';
        $scope.customerDefinition.BuyerInfo.middleName = '';
        $scope.customerDefinition.BuyerInfo.lastName = '';
        $scope.customerDefinition.CoBuyerInfo.firstName = '';
        $scope.customerDefinition.CoBuyerInfo.middleName = '';
        $scope.customerDefinition.CoBuyerInfo.lastName = '';
        $scope.customerDefinition.BusinessInfo.businessName = '';
        $scope.customerDefinition.BusinessInfo.driverFirstName = '';
        $scope.customerDefinition.BusinessInfo.driverLastName = '';
    };
    $scope.customerType =  true;
    //we retrieved from an existing quote - fill in the values
    $scope.$on(quoteCreationEvents.customerDataRetrieved, function(event, custArgs) {
        //custArgs in models/customer-info.js
        $scope.customerDefinition = rateQuoteCoordService.CustomerData;
    });
    //
    $scope.$on(quoteCreationEvents.loadingExistingQuote, function(event, args) {
        //quoteInitializationService.initializeCustomerData();
        $scope.customerDefinition = rateQuoteCoordService.CustomerData;
    });
    //clear data and re-run setup to see if integration data is being passed in
    $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
        $scope.setupInitialCustomerInfo();
    });
    //if we are "integrating" from another page or MenuPro, grab the "prefill" data
    $scope.setupInitialCustomerInfo = function() {
        $scope.customerDefinition = null;

        quoteInitializationService.initializeCustomerData();

        $scope.customerDefinition = rateQuoteCoordService.CustomerData;
        $scope.customerType = (!($scope.customerDefinition.BusinessInfo && $scope.customerDefinition.BusinessInfo.businessName.length > 1));

        if (!rateQuoteRetrievalCoordService.inQuoteRetrieval())
            $scope.customerChanged();
    };

    $scope.lookupCustomerDefinitionLocationByZipCode = function(zipCode) {
        locationService.getLocationInfoFromZipCode(zipCode)
            .then(function(data) {
                _.extend($scope.customerDefinition, data);
            });
    };
}]);
